import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {QuickCard} from '../classes/QuickCard';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export class QuickCardService {
  constructor(private httpClient: HttpClient) { }

  public getAll(status: string): Observable<QuickCard[]> {
    return this.httpClient.get<QuickCard[]>(`${environment.backendApiUrl}/v1/admin/quick-cards?status=` + status, httpOptions);
  }

  public getUserQuickCards(status: string): Observable<QuickCard[]> {
    return this.httpClient.get<QuickCard[]>(`${environment.backendApiUrl}/v1/quick-cards?status=` + status, httpOptions);
  }
}
